@if (siteFooter()) {
  <footer class="app-footer">
    <div class="app-footer__content">
      <span class="app-footer__copyright">
        {{ siteFooter() }}
      </span>
    </div>
  </footer>
}